import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from "@angular/core";

import { AppearanceService } from "./appearance.service";

export function provideAppearance(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(() => inject(AppearanceService).init())]);
}
